<template>
  <v-row>
    <v-col cols="12">
      <AlertsTemplate
        :page_content="page_content"
        :isPowerdata="isPowerdata"
      ></AlertsTemplate>
    </v-col>
  </v-row>
</template>

<script>
import AlertsTemplate from "../components/AlertsTemplate";
import { content } from "../../config/alerts.js";

export default {
  name: "Alerts",
  components: { AlertsTemplate },
  data: function () {
    return {
      page_content: null,
      isPowerdata: false,
    };
  },
  created() {
    this.page_content = content;
  },
};
</script>
